import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { AddEdit } from "./AddEdit";
import { List } from "./List";

function Articulos({ match }) {
    const { path } = match;

    //console.log(`path- ${match.url}/add`);
    console.log(path+"- articulos list");
    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/edit/:id`} component={AddEdit} />
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    ); 
}


export { Articulos };

//export default Sucurs;